(function () {

	angular.module('qbePortal').controller('QBMaxNoClaimBonus', QBMaxNoClaimBonus);

	QBMaxNoClaimBonus.$inject = ['$scope'];

	function QBMaxNoClaimBonus($scope) {
		var vm = this;

		vm.$onInit = function () {
			vm.fieldValue = vm.ngModel;
		}

		function calcAge() {
			return (moment(new Date()).diff(moment(vm.dob, 'DD/MM/YYYY'), 'years', true));
		}

		vm.getFilteredOptions = function () {

			var fullOptions = vm.options.slice();

			//if yerls help is not greater than 5 the 0 is the only option
			if (vm.yearsHeld !== 'greaterThan_5') {
				return fullOptions.splice(0, 1);
			}

			var age = calcAge();
			if (age == 22) {
				fullOptions = fullOptions.splice(0, 1);
			} else if (age == 23) {
				fullOptions = fullOptions.splice(0, 2);
			} else {
				fullOptions = fullOptions.splice(0, 3);
			}

			return fullOptions;

		}


		vm.registerHierarchy = function (name, setHierarchyFn) {
			vm.setHierarchy({
				name: name,
				setHierarchyFn: setHierarchyFn
			});
		}

		vm.onValueChanged = function () {
			vm.update({
				name: vm.name,
				value: vm.fieldValue
			});
		}


	}

	angular.module('qbePortal').component('qbMaxNoClaimBonus', {
		templateUrl: '../ngviews/components/qbMaxNoClaimBonus.html',
		controller: QBMaxNoClaimBonus,
		controllerAs: 'vm',
		bindings: {
			options: '<',
			name: '@',
			ngModel: '<',
			update: '&',
			setHierarchy: '&',
			yearsHeld: '<',
			dob: '<'
		}
	});
})();
